export function moveKey(from, to, originalObject) {
    let obj = {};
    if (from < to) {
        for (let pattern in originalObject) {
            pattern = parseInt(pattern);
            if (pattern > to) {
                obj[pattern] = originalObject[pattern];
            } else if (pattern > from) {
                obj[pattern - 1] = originalObject[pattern];
            } else if (pattern === from) {
                obj[to] = originalObject[from];
            } else {
                obj[pattern] = originalObject[pattern];
            }
        }
    } else {
        for (let pattern in originalObject) {
            pattern = parseInt(pattern);
            if (pattern < to) {
                obj[pattern] = originalObject[pattern];
            } else if (pattern === from) {
                obj[to] = originalObject[from];
            } else if (pattern >= to) {
                obj[pattern + 1] = originalObject[pattern];
            } else {
                obj[pattern] = originalObject[pattern];
            }
        }
    }

    return obj;
};

export function deleteKey(i, originalObject) {
    let obj = {};
    for (let key in originalObject) {
        key = parseInt(key);
        if (key === i) {
            continue;
        }

        if (key > i) {
            obj[key - 1] = originalObject[key];
        } else {
            obj[key] = originalObject[key];
        }
    }
    return obj;
};
